/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import getSchema from "../../lib/api/getSchema";
import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

/**
 * @COMPONENT_NAME MachineRealTimeDataHistory
 * @DESCRIPTION 설비의 실시간 데이터 이력을 관리하는 화면 컴포넌트
 *              설비별 실시간 수집 데이터 이력 조회 화면을 제공
 *
 * @PASSTHROUGH_PROPS
 * @CALLBACKS
 *   - {Function} onApiInitialized - API 초기화 시 호출되는 콜백
 *   - {Function} onInitialized - 그리드 초기화 시 호출되는 콜백
 */

const MachineRealTimeDataHistory = () => {
    const table = "MachineRealTimeDataHistory";
    const view = "VwMachineRealTimeDataHistory";

    const [schema, setSchema] = useState();
    const [grid, setGrid] = useState();
    const [api, setApi] = useState();
    const [machineRealTimeDataHistorySelect, setMachineRealTimeDataHistorySelect] = useState();

    const { t } = useTranslation();

    useEffect(() => {
        let mounted = true;

        async function schemaSetting() {
            let schema = await getSchema(table);
            if (mounted) {
                setSchema(schema);
            }
        }

        schemaSetting();
        return () => {
            mounted = false;
        };
    }, []);

    useEffect(() => {
        if (grid) {
            grid.selectionChanged.addHandler((grid, event) => {
                if (grid.selectedItems && grid.selectedItems[0]) {
                    setMachineRealTimeDataHistorySelect(grid.selectedItems[0]);
                } else {
                    setMachineRealTimeDataHistorySelect([]);
                }
            });

            grid.itemsSourceChanged.addHandler((grid, event) => {
                if (grid.selectedItems && grid.selectedItems[0]) {
                    setMachineRealTimeDataHistorySelect(grid.selectedItems[0]);
                } else {
                    setMachineRealTimeDataHistorySelect([]);
                }
            });
        }
    }, [grid]);

    const onApiInitialized = (api) => {
        setApi(api);
    };

    const onInitialized = (grid) => {
        setGrid(grid);
    };

    return (
        <BasicCrudScreenType
            id={table}
            table={table}
            view={view}
            onInitialized={onInitialized}
            onApiInitialized={onApiInitialized}
            noCreate
            noEdit
            noDelete
            noExcel
        />
    );
};

export default MachineRealTimeDataHistory;
